module.exports = __webpack_public_path__ + "img/Wasserflasche.9e34a4c1.png";